<template>
  <div
    class="ims-modal"
    :class="`${show ? 'visible' : 'hidden'} type-${type}`"
    :aria-hidden="`${show ? false : true}`"
    @click="backgroundClicked"
  >
    <section class="ims-modal-window" v-on:click.stop>
      <ims-toolbar color="primary" :inverse="true" v-bind:class="`modal-header ${headerClasses}`">
        <div class="left">
          <ims-button
            type="clear"
            aria-label="Close Panel"
            class="btn-icon"
            v-if="canClose"
            v-on:click="close()"
          >
            <ims-icon color="white" icon="close" />
          </ims-button>
        </div>
        <div class="middle">{{ title }}</div>
        <div class="right">
          <slot name="header-right"></slot>
        </div>
      </ims-toolbar>
      <slot name="header" />
      <main :class="`modal-body flex-shrink flex-grow ${padding ? 'p-3' : ''}`">
        <slot />
      </main>
      <div class="footer-bar" color="white">
        <slot name="footer" />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    },
    type: {
      type: String,
      default: 'full'
    },
    headerClasses: {
      type: String,
      default() {
        return 'header-class';
      }
    },
    padding: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default() {
        return false;
      }
    },
    backgroundClose: {
      type: Boolean,
      default: true
    },
    canClose: {
      type: Boolean
    },
    onClose: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    backgroundClicked() {
      if (this.backgroundClose) {
        this.$emit('close');
      }
    },
    close() {
      this.$emit('close');
      if (this.onClose) {
        this.onClose();
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.ims-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  z-index: $zindex-modal-backdrop;

  @include media-breakpoint-up(sm) {
    justify-content: center;
  }

  .footer-bar {
    .ims-toolbar {
      border-top: solid 1px rgba(0, 0, 0, 0.2);
    }
  }

  &.visible {
    transition: all 0.2s ease-in-out;
    background-color: rgba(0, 0, 0, 0.6);
  }
  &.hidden {
    transition: all 0.2s ease-in-out;
    opacity: 0;
    pointer-events: none;
    .ims-modal-window {
      transition: all 0.2s ease-in-out;
      transform: translateY(300px);
    }
  }

  &.type-full {
    padding: 0;
    .ims-modal-window {
      min-width: 100%;
      min-height: 100%;
      @include media-breakpoint-up(md) {
        min-height: auto;
        min-width: 500px;
        max-width: 500px;
        max-height: 700px;
        height: auto !important;
      }
    }
  }

  &.type-bottom {
    padding: 0;
    justify-content: flex-end;
    @include media-breakpoint-down(xs) {
      padding-left: 16px;
      padding-right: 16px;
    }
    .ims-modal-window {
      min-width: 300px;
      max-width: 400px;
      width: 100%;
      margin-bottom: 16px;
    }
  }

  .ims-modal-window {
    transition: all 0.2s ease-in-out;
    // padding-bottom: 20px;
    background-color: #fff;
    border-radius: $modal-radius;
    max-height: 600px;
    min-height: 100px;
    width: 500px;
    min-width: 300px;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    position: relative;
    box-shadow: $shadow-bottom-2;
    overflow: hidden;
  }

  .ims-modal-window footer {
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    padding: $padding-xs;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-bottom-left-radius: $modal-radius;
    border-bottom-right-radius: $modal-radius;
    z-index: 100;
  }

  .ims-modal-window .modal-body {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-y: auto;
    top: $size-header-height-sm;
    background-color: $color-bg;
  }

  .ims-modal-window header {
    border-top-left-radius: $modal-radius;
    border-top-right-radius: $modal-radius;
    padding-left: $padding-sm;
    padding-right: $padding-sm;
    position: relative;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
    .left {
      width: 15%;
      button {
        margin: 0;
      }
    }
    .middle {
      text-align: center;
      font-weight: bold;
      font-size: 1.1rem;
      line-height: 1.2rem;
    }
    .right {
      width: 15%;
    }
  }
}
</style>
